import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import { TCompanyId } from '/src/lib/models';
import {
  TCreateCompanyRequest,
  TCreateCompanyResponse,
  TDeleteCompanyResponse,
  TGetCompanyResponse,
  TListCompaniesRequest,
  TListCompaniesResponse,
  TUpdateCompanyRequest,
  TUpdateCompanyResponse,
} from '/src/lib/types';

export class CompanyService {
  /**
   * List Companies
   * @returns Company[]
   * @throws ApiError
   */
  public static async query(req?: TListCompaniesRequest): CancelablePromise<TListCompaniesResponse> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/companies',
      query: req,
    })) as TListCompaniesResponse;

    return res;
  }

  /**
   * Get Company
   * @param id TCompanyId
   * @returns Company
   * @throws ApiError
   */
  public static async get(id: TCompanyId): CancelablePromise<TGetCompanyResponse> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/companies/{id}',
      path: { id },
    })) as TGetCompanyResponse;

    return res;
  }

  /**
   * Create Company
   * @param company Company
   * @returns Company
   * @throws ApiError
   */
  public static async create(req: TCreateCompanyRequest): CancelablePromise<TCreateCompanyResponse> {
    const res = (await __request(OpenAPI, {
      method: 'POST',
      url: '/companies',
      body: req,
    })) as TCreateCompanyResponse;

    return res;
  }

  /**
   * Update Company
   * @param company Company
   * @returns Company
   * @throws ApiError
   */
  public static async update(id: TCompanyId, req: TUpdateCompanyRequest): CancelablePromise<TUpdateCompanyResponse> {
    const res = (await __request(OpenAPI, {
      method: 'PUT',
      url: '/companies/{id}',
      path: { id },
      body: req,
    })) as TUpdateCompanyResponse;

    return res;
  }

  /**
   * Deactivate Company
   * @param id TCompanyId
   * @returns Company
   * @throws ApiError
   */
  public static async remove(id: TCompanyId): CancelablePromise<TDeleteCompanyResponse> {
    const res = (await __request(OpenAPI, {
      method: 'DELETE',
      url: '/companies/{id}',
      path: { id },
    })) as TDeleteCompanyResponse;

    return res;
  }
}
